import React from "react";
import Container from "../../Components/Container";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import {
  FiArrowUpRight,
  FiPlus,
  FiTrash2,
  FiX,
  FiCalendar,
  FiTrendingUp,
  FiDollarSign,
  FiPackage,
  FiPieChart,
  FiLayers,
} from "react-icons/fi";
import { IoMdTrendingDown } from "react-icons/io";
const safeJson = (raw, fallback) => {
  if (raw == null || raw === "") return fallback;
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
};

const fmtMoney = (n) => {
  const x = Number(n);
  if (!Number.isFinite(x)) return "0";
  return x.toLocaleString("tr-TR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

const Panel = () => {
  const navigate = useNavigate();
  const [text, setText] = useState("");
  const [price, setPrice] = useState(0);
  const [cost, setCost] = useState(0);
  const [count, setCount] = useState([]);
  const [cats, setCats] = useState([]);
  const [open, setOpen] = useState(false);
  const [list, setList] = useState([]);
  const [amount, setAmount] = useState();
  const [type, setType] = useState();
  const [totalCost, setTotalCost] = useState();
  const [retur, setReturn] = useState(0);
  const [returCost, setReturnCost] = useState(0);

  const [dailyCount, setDailyCount] = useState(0);

  useEffect(() => {
    const dateStr = new Date().toLocaleDateString();

    const formdata = new FormData();
    formdata.append("action", "select");
    formdata.append("date", dateStr);
    fetch(process.env.REACT_APP_BASE_URL + "panel.php", {
      method: "POST",
      body: formdata,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 400) return;

        const priceObj = safeJson(data["price"], {});
        const retObj = safeJson(data["r"], {});
        const costObj = safeJson(data["cost"], {});
        const totalCostObj = safeJson(data["totalCost"], {});
        const listParsed = safeJson(data["m"], []);
        const retCostObj = safeJson(data["totalReturnCost"], {});

        setPrice(Number(priceObj.price) || 0);
        setReturn(Number(retObj.price) || 0);
        setCost(Number(costObj.cost) || 0);
        setTotalCost(totalCostObj.totalCost);
        setList(Array.isArray(listParsed) ? listParsed : []);
        setReturnCost(Number(retCostObj.r) || 0);
      })
      .catch(() =>
        toast.error("Panel verileri yüklenirken bir hata oluştu")
      );

    const selectcount = new FormData();
    selectcount.append("action", "selectCount");
    fetch(process.env.REACT_APP_BASE_URL + "panel.php", {
      method: "POST",
      body: selectcount,
    })
      .then((res) => res.json())
      .then((data) => {
        setCount(data["store"]);
        setCats(data["cat"]);
      })
      .catch(() =>
        toast.error("Stok bilgisi yüklenirken bir hata oluştu")
      );

    const salesDayForm = new FormData();
    salesDayForm.append("action", "selectDay");
    salesDayForm.append("date", dateStr);
    fetch(process.env.REACT_APP_BASE_URL + "sales.php", {
      method: "POST",
      body: salesDayForm,
    })
      .then((res) => res.json())
      .then((data) => {
        if (!Array.isArray(data)) {
          setDailyCount(0);
          return;
        }
        setDailyCount(
          data.reduce((acc, curr) => acc + Number(curr.count), 0)
        );
      })
      .catch(() => setDailyCount(0));
  }, []);

  const toggleHandeler = (e) => {
    e.preventDefault();
    if (e.target.classList.contains("close")) {
      setOpen(false);
    }
  };

  const sendList = () => {
    const start = new Date().toLocaleDateString();
    const formdata = new FormData();
    formdata.append("action", "insert");
    formdata.append(
      "data",
      JSON.stringify({
        type: type,
        text: text,
        amount: amount,
        date: start,
      })
    );
    fetch(process.env.REACT_APP_BASE_URL + "panel.php", {
      method: "POST",
      body: formdata,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status !== 200) {
          toast.error(data.message);
        } else {
          setList((prev) => [
            ...prev,
            {
              type: type,
              text: text,
              amount: amount,
              date: start,
            },
          ]);

          toast.success(data.message);
        }
      })
      .catch(() => toast.error("Gider kaydedilemedi"));
  };

  const deleteList = (item) => {
    const formdata = new FormData();
    formdata.append("action", "deleteList");
    formdata.append("id", item.id);
    fetch(process.env.REACT_APP_BASE_URL + "panel.php", {
      method: "POST",
      body: formdata,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status !== 200) {
          toast.error(data.message);
        } else {
          toast.success(data.message);
          setList((prev) => prev.filter((i) => i.id !== item.id));
        }
      })
      .catch(() => toast.error("Silinemedi"));
  };

  const linkHandel = (p1, p2) => {
    navigate(
      `/dashboard/details?c=${encodeURIComponent(
        p1
      )}&s=${encodeURIComponent(p2)}`
    );
  };

  const netRevenue = Number(price) - Number(retur);
  const profitNumer =
    Number(price) -
    Number(cost) -
    (Number(retur) - Number(returCost));
  const profitShare =
    netRevenue !== 0 && Number.isFinite(netRevenue)
      ? Math.min(100, Math.max(0, (profitNumer / netRevenue) * 100))
      : 0;

  return (
    <Container bg="#f8fafc">
      <Toaster
        position="top-center"
        toastOptions={{ className: "text-sm font-medium shadow-lg" }}
      />

      {open && (
        <div
          onClick={(e) => toggleHandeler(e)}
          className="fixed close z-50 inset-0 flex items-center justify-center bg-slate-900/50 p-4 backdrop-blur-sm"
        >
          <div
            className="w-full max-w-2xl max-h-[90vh] overflow-y-auto rounded-2xl border border-slate-200 bg-white shadow-2xl"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="expense-modal-title"
          >
            <div className="sticky top-0 z-10 flex items-center justify-between border-b border-slate-100 bg-white/95 px-6 py-4 backdrop-blur-sm">
              <h2
                id="expense-modal-title"
                className="text-lg font-bold tracking-tight text-slate-900"
              >
                Yeni gider
              </h2>
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="rounded-xl p-2 text-slate-500 transition hover:bg-slate-100 hover:text-slate-800"
                aria-label="Kapat"
              >
                <FiX size={20} />
              </button>
            </div>

            <div className="space-y-5 px-6 py-6">
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                <div>
                  <label
                    htmlFor="amount"
                    className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-slate-500"
                  >
                    Tutar
                  </label>
                  <div className="relative">
                    <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-slate-400">
                      <FiDollarSign size={16} />
                    </span>
                    <input
                      id="amount"
                      type="number"
                      placeholder="0,00"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      className="w-full rounded-xl border border-slate-200 bg-slate-50/80 py-2.5 pl-10 pr-3 text-sm text-slate-900 shadow-sm placeholder:text-slate-400 focus:border-indigo-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500/20"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="type"
                    className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-slate-500"
                  >
                    Tür
                  </label>
                  <select
                    id="type"
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                    className="w-full rounded-xl border border-slate-200 bg-slate-50/80 px-3.5 py-2.5 text-sm text-slate-900 shadow-sm focus:border-indigo-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500/20"
                  >
                    <option value={0}>Tür seçiniz</option>
                    <option value="Günlük">Günlük</option>
                    <option value="Aylık">Aylık</option>
                    <option value="Personel">Personel</option>
                    <option value="Faturalar">Faturalar</option>
                    <option value="Mültarif">Mültarif</option>
                    <option value="Vergi">Vergi</option>
                  </select>
                </div>
              </div>

              <div>
                <label
                  htmlFor="text"
                  className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-slate-500"
                >
                  Açıklama
                </label>
                <textarea
                  id="text"
                  placeholder="Açıklama…"
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  className="w-full rounded-xl border border-slate-200 bg-slate-50/80 px-3.5 py-2.5 text-sm text-slate-900 shadow-sm placeholder:text-slate-400 focus:border-indigo-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500/20"
                  rows={2}
                />
              </div>

              <button
                type="button"
                onClick={sendList}
                disabled={!amount || !text || type === 0}
                className={`flex w-full items-center justify-center gap-2 rounded-xl py-3 text-sm font-semibold transition focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 ${
                  !amount || !text || type === 0
                    ? "cursor-not-allowed bg-slate-200 text-slate-500"
                    : "bg-indigo-600 text-white shadow-lg shadow-indigo-500/25 hover:bg-indigo-700"
                }`}
              >
                <FiPlus size={18} />
                Gider ekle
              </button>
            </div>

            {list.length > 0 && (
              <div className="border-t border-slate-100 px-6 py-5">
                <h3 className="mb-3 text-sm font-bold text-slate-800">
                  Gider listesi
                </h3>
                <div className="max-h-64 space-y-2 overflow-y-auto rounded-xl border border-slate-200 bg-slate-50/50 p-2">
                  {list.map((item, index) => (
                    <div
                      key={item.id != null ? item.id : index}
                      className="flex items-center justify-between gap-3 rounded-lg border border-slate-100 bg-white p-3 shadow-sm"
                    >
                      <div className="flex min-w-0 items-start gap-3">
                        <div
                          className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${
                            item.type === "Günlük"
                              ? "bg-blue-100 text-blue-600"
                              : item.type === "Personel"
                              ? "bg-purple-100 text-purple-600"
                              : item.type === "Faturalar"
                              ? "bg-amber-100 text-amber-600"
                              : "bg-slate-100 text-slate-600"
                          }`}
                        >
                          {item.type === "Günlük" && <FiCalendar size={18} />}
                          {item.type === "Personel" && (
                            <FiTrendingUp size={18} />
                          )}
                          {item.type === "Faturalar" && (
                            <FiDollarSign size={18} />
                          )}
                          {!["Günlük", "Personel", "Faturalar"].includes(
                            item.type
                          ) && <FiPieChart size={18} />}
                        </div>
                        <div className="min-w-0">
                          <p className="truncate font-medium text-slate-900">
                            {item.text}
                          </p>
                          <p className="text-xs text-slate-500">
                            {item.type} · {item.date}
                          </p>
                        </div>
                      </div>
                      <div className="flex shrink-0 items-center gap-2">
                        <span className="text-sm font-semibold tabular-nums text-slate-900">
                          {fmtMoney(item.amount)} ₺
                        </span>
                        {item.id != null && (
                          <button
                            type="button"
                            onClick={() => deleteList(item)}
                            className="rounded-lg p-2 text-red-600 transition hover:bg-red-50"
                            aria-label="Sil"
                          >
                            <FiTrash2 size={16} />
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="mx-auto w-full max-w-[1400px] space-y-8 px-4 pb-16 pt-2 sm:px-6 lg:px-8">
        <div className="rounded-2xl border border-slate-200/80 bg-white p-6 shadow-sm shadow-slate-200/50 sm:p-8">
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div className="flex items-start gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-500 to-violet-600 text-white shadow-md shadow-indigo-500/25">
                <FiLayers className="text-xl" />
              </div>
              <div>
                <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
                  Panel özeti
                </h1>
                <p className="mt-1 max-w-2xl text-sm leading-relaxed text-slate-600">
                  Bugünün ciro, maliyet ve kar göstergeleri; depo bazlı stok ve
                  kategori kırılımına buradan ulaşın.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-5 lg:items-stretch">
          <Link
            to="/dashboard/daily"
            className="group relative flex min-h-[104px] items-center overflow-hidden rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm transition hover:border-indigo-200 hover:shadow-md"
          >
            <div className="flex w-full items-center gap-4 pr-8">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-indigo-50 text-indigo-600 ring-1 ring-indigo-100">
                <FiPackage className="text-[22px]" strokeWidth={2} />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                  Günlük satış adedi
                </p>
                <p className="text-2xl font-bold leading-tight tabular-nums text-slate-900">
                  {dailyCount}
                </p>
              </div>
            </div>
            <FiArrowUpRight className="pointer-events-none absolute right-4 top-1/2 h-5 w-5 -translate-y-1/2 text-indigo-400 opacity-0 transition group-hover:opacity-100" />
          </Link>

          <div className="flex min-h-[104px] flex-col justify-center rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm">
            <div className="flex items-center gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-emerald-50 text-emerald-600 ring-1 ring-emerald-100">
                <FiTrendingUp className="text-[22px]" strokeWidth={2} />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                  Günlük kazanç
                </p>
                <p className="text-2xl font-bold leading-tight tabular-nums text-slate-900">
                  {fmtMoney(Number(price) - Number(retur))}{" "}
                  <span className="text-sm font-semibold text-slate-500">₺</span>
                </p>
              </div>
            </div>
          </div>

          <div className="flex min-h-[104px] flex-col justify-center rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm">
            <div className="flex items-center gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-red-50 text-red-600 ring-1 ring-red-100">
                <IoMdTrendingDown className="text-[24px]" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                  Günlük maliyet
                </p>
                <p className="text-2xl font-bold leading-tight tabular-nums text-slate-900">
                  {fmtMoney(Number(cost) - Number(returCost))}{" "}
                  <span className="text-sm font-semibold text-slate-500">₺</span>
                </p>
              </div>
            </div>
          </div>

          <div className="flex min-h-[104px] flex-col justify-center gap-3 rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm">
            <div className="flex items-center gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-amber-50 text-amber-600 ring-1 ring-amber-100">
                <FiDollarSign className="text-[22px]" strokeWidth={2} />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                  Günlük kar
                </p>
                <p className="text-2xl font-bold leading-tight tabular-nums text-slate-900">
                  {fmtMoney(profitNumer)}{" "}
                  <span className="text-sm font-semibold text-slate-500">₺</span>
                </p>
              </div>
            </div>
            <div className="h-1.5 overflow-hidden rounded-full bg-slate-100">
              <div
                className="h-full rounded-full bg-amber-500 transition-[width]"
                style={{ width: `${profitShare}%` }}
              />
            </div>
          </div>

          <button
            type="button"
            onClick={() => setOpen(true)}
            className="flex min-h-[104px] flex-col justify-center rounded-2xl border border-slate-200/80 bg-white p-5 text-left shadow-sm transition hover:border-indigo-200 hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
          >
            <div className="flex items-center gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-rose-50 text-rose-600 ring-1 ring-rose-100">
                <IoMdTrendingDown className="text-[24px]" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                  Günlük gider
                </p>
                <p className="text-2xl font-bold leading-tight tabular-nums text-slate-900">
                  {totalCost == null ? "0" : fmtMoney(totalCost)}{" "}
                  <span className="text-sm font-semibold text-slate-500">₺</span>
                </p>
              </div>
            </div>
            <p className="mt-3 flex items-center gap-1.5 text-xs font-medium text-indigo-600">
              <FiPlus size={14} className="shrink-0" strokeWidth={2.5} />
              Yeni gider ekle
            </p>
          </button>
        </div>

        <section aria-label="Depo stokları">
          <div className="mb-5 flex flex-col gap-1 sm:flex-row sm:items-end sm:justify-between">
            <h2 className="text-xl font-bold tracking-tight text-slate-900">
              Stok adetleri
            </h2>
            <p className="text-sm text-slate-600">
              Depo kartlarında kategori bazlı adet ve tutarlar; detaya gitmek
              için satıra tıklayın.
            </p>
          </div>
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
            {Array.isArray(count) &&
              count.map((subArray, index) =>
                Array.isArray(subArray)
                  ? subArray.map((item, subIndex) =>
                      item.total != null ? (
                        <div
                          key={`${index}-${subIndex}`}
                          className="flex flex-col overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-sm transition hover:shadow-md"
                        >
                          <div className="flex items-start justify-between gap-3 border-b border-slate-100 px-5 py-4">
                            <h3 className="text-lg font-bold capitalize text-slate-900">
                              {item.store}
                            </h3>
                            <span className="shrink-0 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-800 ring-1 ring-emerald-200/60">
                              Aktif
                            </span>
                          </div>

                          <div className="grid grid-cols-3 gap-2 px-5 pt-4">
                            <div className="rounded-xl bg-orange-50 p-3 text-center ring-1 ring-orange-100">
                              <p className="text-xl font-bold tabular-nums text-orange-900">
                                {item.total}
                              </p>
                              <p className="text-[10px] font-semibold uppercase tracking-wide text-orange-700/80">
                                Toplam adet
                              </p>
                            </div>
                            <div className="rounded-xl bg-red-50 p-3 text-center ring-1 ring-red-100">
                              <p className="text-sm font-bold tabular-nums text-red-900">
                                {fmtMoney(item.cost)} ₺
                              </p>
                              <p className="text-[10px] font-semibold uppercase tracking-wide text-red-700/80">
                                Maliyet
                              </p>
                            </div>
                            <div className="rounded-xl bg-emerald-50 p-3 text-center ring-1 ring-emerald-100">
                              <p className="text-sm font-bold tabular-nums text-emerald-900">
                                {fmtMoney(item.price)} ₺
                              </p>
                              <p className="text-[10px] font-semibold uppercase tracking-wide text-emerald-700/80">
                                Satış
                              </p>
                            </div>
                          </div>

                          <div className="flex flex-col gap-2 px-5 py-4">
                            <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                              Kategoriler
                            </p>
                            {cats &&
                              cats.map((catItem, catIndex) => {
                                const catData = catItem[0];
                                if (!catData) return null;
                                return (
                                  <button
                                    type="button"
                                    key={catIndex}
                                    onClick={() =>
                                      linkHandel(catData.store, item.store)
                                    }
                                    className="w-full rounded-xl border border-indigo-100 bg-indigo-50/80 p-3 text-left transition hover:border-indigo-200 hover:bg-indigo-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
                                  >
                                    <div className="flex items-start justify-between gap-3">
                                      <div className="min-w-0">
                                        <span className="text-sm font-semibold text-indigo-950">
                                          {catData.store}
                                        </span>
                                        <p className="mt-1 text-xs font-medium text-indigo-700">
                                          <span className="rounded-md bg-white/80 px-1.5 py-0.5 font-bold tabular-nums ring-1 ring-indigo-200/60">
                                            {catData.total}
                                          </span>{" "}
                                          adet
                                        </p>
                                      </div>
                                      <div className="shrink-0 text-right">
                                        <span className="text-sm font-semibold tabular-nums text-indigo-900">
                                          {fmtMoney(catData.price)} ₺
                                        </span>
                                        <p className="text-xs text-indigo-600">
                                          Maliyet: {fmtMoney(catData.cost)} ₺
                                        </p>
                                      </div>
                                    </div>
                                  </button>
                                );
                              })}
                          </div>
                        </div>
                      ) : null
                    )
                  : null
              )}
          </div>
        </section>
      </div>
    </Container>
  );
};

export default Panel;
